








import TabItem from './tab-item.vue';
import { defineComponent, computed } from '@vue/composition-api';
import { biClick } from '@tencent/fit-bi-sdk';
import { jumpPage } from '@tencent/wphk-components-jump-page';
import { amount } from '@tencent/wphk-base-utils';
import { checkIsInSpring } from '@/business/spring';
import { i18n } from '@/i18n';

export default defineComponent({
  name: 'MyWepointsTab',
  components: {
    TabItem,
  },
  props: {
    num: {
      type: Number,
      default: 0,
      required: true,
    },
  },
  setup(props) {
    const biExt = computed(() => ({
      fcount: `${props.num}`,
    }));
    const showNum = computed(() => amount.toCurrency(`${props.num}`, 2, false));
    return {
      showNum,
      biExt,
      tip: checkIsInSpring() ? i18n('消费赚多倍积分') : i18n('消费赚积分'),
      clickTab() {
        jumpPage.goWePoints({
          adtag: 'discountCenterHomeWepointsTab',
        });
        biClick('my-wepoints-tab.click|我的积分点击', biExt.value);
      },
    };
  },
});
